import { GenericServiceBase } from "../generic-service";
import { ResponseInbox, UnconnectedInbox, LinkedInbox } from "../inbox/inbox.service";
import { IdCanal, IdConta, IdInbox, IdUsuario } from "../common-types";
import type { SoundPreferences } from "@/stores/app/soundStore";

export class UsuarioAuthService extends GenericServiceBase {
  constructor() { super('user-auth') }

  async isLoggedIn() {
    return await this.f.get('/isLoggedIn', undefined, { returnBooleanForLogin: true }) as boolean;
  }

    async login(email: string, senha: string, idConta?: string) {
    return await this.f.post('/login', { email, senha, idConta }, { doNotRedirectOn401: true });
  }

  async logout() {
    return await this.f.post('/logout');
  }

  async refreshToken() {
    return await this.f.post('/refresh-token');
  }

  /** @returns Objeto contendo token com validade de 30s usado para estabelecer a conexão websocket. */
  async getWebsocketToken() {
    return await this.f.get('/ws-token') as { wsToken: string };
  }

  async whoAmI() {
    return await this.f.get('/who-am-i') as { id: IdUsuario, nome: string, email: string, canais: Record<IdCanal, boolean>, contas: Record<IdConta, boolean>, permissoes: Record<string, boolean>, inboxes: Record<IdInbox, ResponseInbox>, inboxesNaoConectadas?: UnconnectedInbox[], inboxesVinculados?: LinkedInbox[], foto: string | undefined, hasGlobalAccess: boolean, doisFatores?: boolean, notificacaoNavegador?: boolean, tema?: 'light' | 'dark', som?: SoundPreferences, simulado?: boolean, nomeAdmin?: string, simulacaoExpiraEm?: number };
  }

  async simularLogin(idUsuario: IdUsuario, idConta?: IdConta) {
    return await this.f.get('/simular-login', { idUsuario, idConta });
  }

  async tokenLogin(token: string) {
    return await this.f.post('/token-login', { token }, { doNotRedirectOn401: true });
  }

  async switchConta(idConta: IdConta) {
    return await this.f.post('/switch-conta', { idConta });
  }

  async forgotPassword(email: string) {
    return await this.f.post('/forgot-password', { email }, { doNotRedirectOn401: true });
  }

  async resetPassword(token: string, novaSenha: string) {
    return await this.f.post('/reset-password', { token, novaSenha }, { doNotRedirectOn401: true });
  }

  async verify2fa(token: string) {
    return await this.f.post('/verify-2fa', { token }, { doNotRedirectOn401: true });
  }

  async resend2fa() {
    return await this.f.post('/resend-2fa', {}, { doNotRedirectOn401: true });
  }
}
